var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath1104(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.639,
    height: 20.072,
    viewBox: "0 0 28.639 20.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M27.775,4H4.864a2.7,2.7,0,0,0-2.85,2.509L2,21.563a2.712,2.712,0,0,0,2.864,2.509H27.775a2.712,2.712,0,0,0,2.864-2.509V6.509A2.712,2.712,0,0,0,27.775,4Zm0,5.018L16.32,15.291,4.864,9.018V6.509L16.32,12.782,27.775,6.509Z",
    transform: "translate(-2 -4)",
    fill: "#f1f2f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath1104);
export default __webpack_public_path__ + "static/media/Path 1104.c733b1c20b1c594cd82d51c3a1fb674c.svg";
export { ForwardRef as ReactComponent };